/* ==========================================================================
   Peinture Nature - fiche produit
   Selection de variante, changement de prix et d'image. JavaScript natif.
   ========================================================================== */

const donnees = document.querySelector('[data-pn-variantes]');
if (donnees) {
  const variantes = JSON.parse(donnees.textContent);
  const champId = document.querySelector('[data-pn-id-variante]');
  const zonePrix = document.querySelector('[data-pn-prix]');
  const bouton = document.querySelector('[data-pn-ajouter]');
  // Le libelle vient du reglage du bloc « Bouton d'achat ». On le memorise
  // pour le restaurer, au lieu de le reecrire en dur comme le faisait la
  // premiere version, qui ecrasait silencieusement le texte choisi.
  const libelleAchat = bouton.textContent.trim();
  // Deux scenes possibles : la piece pour les grands formats, une vue
  // rapprochee pour les petits. On garde la reference sur celle qui est
  // pertinente pour le format choisi.
  const scenes = [...document.querySelectorAll('[data-pn-echelle]')];
  const scene = scenes[0] || null;
  let vueChoisieALaMain = false;
  const enAnglais = document.documentElement.lang === 'en';
  const libelleIndispo = enAnglais ? 'Unavailable' : 'Indisponible';

  const formatPrix = (centimes) =>
    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(centimes / 100);

  function selectionCourante() {
    return [...document.querySelectorAll('.pn-variantes__champ:checked')]
      .sort((a, b) => a.dataset.pnOption - b.dataset.pnOption)
      .map((c) => c.value);
  }

  // Calque de cadre : on montre celui de la finition choisie, on masque les
  // autres. Tous sont deja dans la page, donc le changement est instantane.
  function afficherCalque() {
    const choisi = [...document.querySelectorAll('.pn-variantes__champ:checked')]
      .map((c) => c.value);
    document.querySelectorAll('[data-pn-calque]').forEach((el) => {
      el.hidden = !choisi.includes(el.dataset.pnCalque);
    });

    // Marges du cadre. L'oeuvre est centree dans un carre : en paysage elle
    // prend toute la largeur et le blanc va en haut et en bas, en portrait
    // c'est l'inverse. On rentre donc le cadre de ces marges, sans rien
    // recadrer ni deformer.
    const d = dimensionsChoisies();
    if (!d) return;
    const [largeur, hauteur] = d;      // le libelle donne largeur x hauteur
    let mx = 0, my = 0;                // marges horizontale et verticale, en %
    if (largeur > hauteur) my = (1 - hauteur / largeur) / 2 * 100;
    else if (hauteur > largeur) mx = (1 - largeur / hauteur) / 2 * 100;

    // PIEGE CORRIGE : le recadrage utilisait le rapport de la TAILLE
    // CHOISIE. Or l'oeuvre a un rapport FIXE dans l'image, et les tailles
    // proposees ne le respectent pas toutes : sur `tableau-provencal`,
    // 30x20, 60x40, 90x60 et 150x100 font 1,50 mais 100x70 fait 1,43.
    // Recadrer a 1,43 rognait donc les cotes. On prend desormais le rapport
    // de la PREMIERE taille de l'option, qui est celui de l'oeuvre et ne
    // change jamais.
    // En paysage la zone est bornee par la LARGEUR du carre, en portrait par
    // sa HAUTEUR. Sans cette distinction, la zone restait carree en portrait
    // et le blanc des cotes n'etait pas mange.
    const [ro, rh] = rapportOeuvre;
    document.querySelectorAll('[data-pn-zone]').forEach((z) => {
      z.style.setProperty('--pn-rapport-oeuvre', `${ro} / ${rh}`);
      if (ro >= rh) { z.style.width = '100%'; z.style.height = 'auto'; }
      else { z.style.height = '100%'; z.style.width = 'auto'; }
    });

    // Epaisseur du cadre, en pourcentage du petit cote. L'oeuvre est rentree
    // d'autant, pour que la moulure occupe la couronne sans mordre dessus.
    const aUnCadre = [...document.querySelectorAll('[data-pn-calque]')]
      .some((el) => choisi.includes(el.dataset.pnCalque));
    document.querySelectorAll('[data-pn-zone]').forEach((z) => {
      z.classList.toggle('pn-produit__zone--cadree', aUnCadre);
      if (!aUnCadre) {
        z.style.setProperty('--pn-cadre', '0px');
        effacerFondCadre(z);
      }
    });

    // PIEGE CORRIGE le 2026-08-01 : cette boucle passait sur les QUATRE
    // calques, y compris les masques, et posait `--pn-cadre` sur la zone
    // dans tous les cas. Sur « Oeuvre sur chassis », qui n'a pas de calque,
    // l'oeuvre etait donc rentree de 6 a 9 % pour loger une moulure qui ne
    // s'affichait jamais, et le grain de toile, pose sur toute la zone,
    // peignait cette couronne vide en gris : le « cadre gris » releve deux
    // fois par Pablo. On ne traite plus que le calque VISIBLE.
    document.querySelectorAll('.pn-produit__zone [data-pn-calque]').forEach((el) => {
      if (el.hidden) return;
      el.style.inset = '0';
      // Epaisseur du cadre. Une baguette fait environ 3,5 cm, mais la
      // traduire brutalement en pourcentage donne 17,5 % sur un 20x30 :
      // physiquement exact, visuellement enorme. Les vrais cadres sont
      // d'ailleurs plus fins sur les petits formats. On borne donc entre
      // 4 et 9 % du petit cote.
      // PIEGE CSS : un pourcentage dans `border-image-width` se rapporte a la
      // LARGEUR pour les cotes gauche et droit, et a la HAUTEUR pour le haut
      // et le bas. Sur un tableau paysage, 9 % de la largeur depasse 9 % de
      // la hauteur : les montants etaient donc plus epais que la traverse,
      // et l'inverse en portrait. Releve de Pablo le 2026-07-31.
      // On calcule une epaisseur en PIXELS, identique sur les quatre cotes,
      // puis on la reexprime en pourcentage propre a chaque axe.
      const zone = el.closest('[data-pn-zone]');
      const b = zone.getBoundingClientRect();
      if (!b.width || !b.height) return;
      const petitCote = Math.min(largeur, hauteur);
      const brut = (3.5 / petitCote) * 100;
      const partPetitCote = Math.min(9, Math.max(4, brut)) / 100;
      // EPAISSEUR EN PIXELS ENTIERS. Les pourcentages par axe donnaient la
      // bonne epaisseur, mais des valeurs fractionnaires : 8,75 % de 229 px
      // font 20,04 px. Un bord de largeur fractionnaire fait apparaitre un
      // LISERE CLAIR a la jonction des neuf zones du calque, visible sur le
      // gros plan envoye par Pablo le 2026-08-01. Une valeur unique en
      // pixels entiers vaut pour les quatre cotes, elle est egale par
      // construction et elle tombe juste sur la grille de pixels.
      const epPx = Math.round(Math.min(b.width, b.height) * partPetitCote);
      el.style.borderImageWidth = `${epPx}px`;
      calerSourceCalque(el, epPx);
      // L'oeuvre est rentree d'un pixel DE MOINS que la moulure, donc elle
      // passe legerement dessous. Rentree d'exactement la meme valeur, le
      // moindre arrondi de rendu laissait apparaitre le fond du conteneur
      // entre les deux : un liseré clair sur tout le pourtour du cadre
      // (releve de Pablo le 2026-08-01). Un pixel de recouvrement coute
      // moins qu'un cheveu blanc.
      // DEUX pixels de recouvrement et non un seul : sur un telephone a
      // densite triple, un pixel CSS vaut trois pixels reels, et un seul
      // suffisait rarement a couvrir le raccord (releve de Pablo le
      // 2026-08-01, le liseré subsistait sur iPhone).
      zone.style.setProperty('--pn-cadre', `${Math.max(0, epPx - 2)}px`);
    });
  }

  /* ----- Mise en situation a l'echelle -----------------------------------
     Place le tableau sur le mur a sa taille reelle. Les dimensions sont
     lues dans le LIBELLE de l'option Taille (« 60x40 cm »), la seule
     source disponible cote client : Shopify n'expose pas les dimensions
     physiques d'une variante autrement.

     Tout est calcule en pourcentage du conteneur. La photo etant carree,
     un pourcentage de largeur vaut un pourcentage de hauteur, donc une
     seule echelle suffit. C'est la raison pour laquelle le visuel de piece
     DOIT etre en 1:1.
  ------------------------------------------------------------------------ */

  // Rapport de l'oeuvre dans l'image, constant pour un produit : c'est
  // celui de la PREMIERE taille proposee. Sert au recadrage du blanc.
  const rapportOeuvre = (() => {
    for (const g of document.querySelectorAll('.pn-variantes__groupe')) {
      for (const c of g.querySelectorAll('.pn-variantes__champ')) {
        const m = c.value.match(/(\d+)\s*[x×]\s*(\d+)/i);
        if (m) return [Number(m[1]), Number(m[2])];
      }
    }
    return [1, 1];
  })();

  function dimensionsChoisies() {
    for (const c of document.querySelectorAll('.pn-variantes__champ:checked')) {
      const m = c.value.match(/(\d+)\s*[x×]\s*(\d+)/i);
      if (m) {
        // Le libelle donne le grand cote en premier : on l'oriente selon
        // les proportions reelles de l'oeuvre, lues sur l'image.
        return [Number(m[1]), Number(m[2])];
      }
    }
    return null;
  }

  function placerAEchelle() {
    if (!scenes.length) return;
    const d = dimensionsChoisies();
    if (!d) return;

    // Choix de la scene, dans cet ordre :
    //   - sous le seuil de grand cote, la vue rapprochee : un 20x30 sur un
    //     mur de salon fait « crotte de mouche » (Pablo, 2026-07-31)
    //   - sinon, si le format est en hauteur et qu'une scene verticale
    //     existe, celle-la : un 100x150 au-dessus d'un canape depasse par
    //     le bas comme par le haut
    //   - sinon la scene principale
    // La vignette de la scene retenue devient la seule visible, pour ne pas
    // proposer deux fois la meme chose dans la galerie.
    const grandCote = Math.max(d[0], d[1]);
    const estPortrait = d[1] > d[0];
    const vues = {
      grand: document.querySelector('[data-pn-scene="grand"]'),
      petit: document.querySelector('[data-pn-scene="petit"]'),
      portrait: document.querySelector('[data-pn-scene="portrait"]'),
    };
    const seuil = Number((vues.grand || vues.petit || {}).dataset?.pnSeuil || 60);
    let cible = vues.grand;
    // Seuil INCLUSIF : un 40x60 a un grand cote de 60, il doit basculer.
    if (vues.petit && grandCote <= seuil) cible = vues.petit;
    else if (vues.portrait && estPortrait) cible = vues.portrait;
    cible = cible || vues.grand || vues.portrait || vues.petit;
    if (!cible) return;

    const idCible = cible.dataset.pnMedia;
    document.querySelectorAll('[data-pn-choisir-media^="echelle"]').forEach((b) => {
      b.closest('li').hidden = b.dataset.pnChoisirMedia !== idCible;
    });
    // Si l'acheteur regardait une autre scene, on bascule sans qu'il clique.
    Object.values(vues).forEach((v) => {
      if (v && v !== cible && !v.hidden) { v.hidden = true; cible.hidden = false; }
    });
    // Meme raison qu'a l'affichage d'un media : la scene qu'on vient de
    // rendre visible peut n'avoir jamais charge ses images.
    if (!cible.hidden) reveillerImages(cible);
    const scene = cible.querySelector('[data-pn-echelle]');
    if (!scene) return;
    const oeuvre = scene.querySelector('[data-pn-echelle-oeuvre]');
    if (!oeuvre) return;

    const echelle = Number(scene.dataset.echelle);        // % de l'image par cm
    const centreX = Number(scene.dataset.centreX);        // % depuis la gauche
    const sol = Number(scene.dataset.sol);                // % depuis le haut
    const hauteurCentre = Number(scene.dataset.hauteurCentre); // cm depuis le sol

    // PIEGE CORRIGE le 2026-07-31 : l'orientation etait deduite des
    // proportions de l'IMAGE, or celle-ci est CARREE pour tous les produits.
    // `naturalWidth >= naturalHeight` etait donc toujours vrai et tous les
    // tableaux se posaient en paysage sur le mur, y compris les portraits.
    // Le libelle donne largeur x hauteur, verifie sur 60 produits tires au
    // sort : on le prend tel quel.
    const largeurCm = d[0];
    const hauteurCm = d[1];

    // Le format demande peut etre MOINS allonge que l'oeuvre : un 100x70
    // vaut 1,43 alors que l'oeuvre en fait 1,50. `object-fit: cover` ne
    // rogne alors que 15 % de chaque cote au lieu des 16,5 % de blanc, et
    // il en restait une bande fine. On agrandit la toile juste ce qu'il
    // faut pour manger le blanc dans tous les cas.
    const rArt = rapportOeuvre[0] / rapportOeuvre[1];
    const rDem = largeurCm / hauteurCm;
    const zoom = rArt >= 1 ? Math.max(1, rArt / rDem) : Math.max(1, rDem / rArt);
    oeuvre.style.setProperty('--pn-zoom-toile', zoom.toFixed(3));

    // GARDE-FOUS D'ACCROCHAGE. Le centre a 145 cm est la regle de musee,
    // mais elle ne tient pas seule : un tableau de 150 cm de haut centre a
    // 145 descend a 70 cm du sol, donc derriere le dossier du canape, et
    // monte a 220 cm. On remonte ou on redescend l'accrochage juste ce qu'il
    // faut, en gardant le centre de reference tant qu'il tient.
    const basMin = Number(scene.dataset.basMin || 0);
    const plafond = Number(scene.dataset.plafond || 235);
    let centreY = hauteurCentre;
    if (basMin > 0 && centreY - hauteurCm / 2 < basMin) centreY = basMin + hauteurCm / 2;
    if (centreY + hauteurCm / 2 > plafond) centreY = plafond - hauteurCm / 2;
    if (centreY - hauteurCm / 2 < 0) centreY = hauteurCm / 2;

    // GARDE-FOU HORIZONTAL. Le point d'accrochage de la scene de salon est a
    // 68 % de la largeur, parce que le canape est a droite. Un panoramique de
    // 180 cm occupe 72 % de l'image : centre a 68 %, il sort du cadre par la
    // droite (releve de Pablo le 2026-08-01 sur la grille 100x50 · 180x90).
    // On ramene le centre juste ce qu'il faut pour que le tableau tienne
    // entier dans la scene. Une photo dont le mur est centre reglerait le
    // sujet a la source, c'est le chantier ouvert du visuel de piece.
    const demiLargeur = (largeurCm * echelle) / 2;
    let centreH = centreX;
    if (centreH - demiLargeur < 0) centreH = demiLargeur;
    if (centreH + demiLargeur > 100) centreH = 100 - demiLargeur;
    if (demiLargeur * 2 >= 100) centreH = 50;

    oeuvre.style.width = `${largeurCm * echelle}%`;
    oeuvre.style.height = `${hauteurCm * echelle}%`;
    oeuvre.style.left = `${centreH}%`;
    oeuvre.style.top = `${sol - centreY * echelle}%`;
    // La largeur est DEDUITE, jamais mesuree sur l'oeuvre : tant que la vue
    // n'est pas celle qu'on regarde, elle est en `display: none` et toute
    // mesure y vaut zero. On part donc de la boite de galerie, toujours
    // rendue, dont la scene occupe exactement la largeur.
    const boite = document.querySelector('.pn-produit__cadre');
    const baseLargeur = (boite && boite.getBoundingClientRect().width)
      || scene.getBoundingClientRect().width;

    // EPAISSEUR DU CADRE SUR LA SCENE. Meme piege que dans la galerie, et il
    // etait reste ici : un pourcentage dans `border-image-width` se rapporte a
    // la LARGEUR pour les montants et a la HAUTEUR pour la traverse. Une
    // valeur unique donnait donc un cadre plus epais sur le grand cote, ce
    // que Pablo a vu revenir sur la scene de salon le 2026-08-01. On calcule
    // 3 cm reels en pixels, puis on les reexprime par axe.
    const largeurOeuvrePx = (baseLargeur * largeurCm * echelle) / 100;
    const hauteurOeuvrePx = (baseLargeur * hauteurCm * echelle) / 100;
    // MEME REGLE QUE LA GALERIE. Trois centimetres reels font 15 % de la
    // hauteur d'un 30x20 : physiquement exact, mais la moulure mangeait
    // presque un tiers du tableau (releve de Pablo le 2026-08-01). On borne
    // donc entre 4 et 9 % du petit cote, exactement comme sur la vue a plat,
    // sinon les deux vues ne montrent pas le meme produit.
    const petitCoteCm = Math.min(largeurCm, hauteurCm);
    const partScene = Math.min(9, Math.max(4, (3.5 / petitCoteCm) * 100)) / 100;
    const epCadrePx = Math.min(largeurOeuvrePx, hauteurOeuvrePx) * partScene;
    const cadreVisible = [...scene.querySelectorAll('[data-pn-calque]')]
      .some((el) => !el.hidden);
    if (largeurOeuvrePx && hauteurOeuvrePx) {
      // Pixels entiers, comme sur la galerie : les bords fractionnaires
      // laissaient un lisere clair a la jonction des neuf zones du calque.
      const epEntier = Math.max(1, Math.round(epCadrePx));
      scene.querySelectorAll('[data-pn-calque]').forEach((el) => {
        el.style.borderImageWidth = `${epEntier}px`;
        calerSourceCalque(el, epEntier);
      });
      // La moulure se dessine A L'INTERIEUR de la boite : sans rentrer
      // l'oeuvre, elle la recouvre. Meme correction que sur la galerie.
      // DEUX PIXELS DE MOINS que l'epaisseur de la moulure, comme sur la
      // galerie. En rentrant l'oeuvre d'exactement l'epaisseur du cadre,
      // les deux bords tombaient au meme endroit, souvent sur une fraction
      // de pixel reel, et une ligne claire apparaissait entre le tableau et
      // la feuillure (releve de Pablo le 2026-08-02, scene du meuble). Le
      // recouvrement fait passer l'oeuvre SOUS la moulure, il n'y a plus de
      // jointure a eclaircir. Sur un cadre d'un pixel on ne rentre rien.
      const retrait = cadreVisible ? Math.max(0, epEntier - 2) : 0;
      oeuvre.style.setProperty('--pn-cadre', `${retrait}px`);
      if (!cadreVisible) effacerFondCadre(oeuvre);
    }

    // OMBRE PORTEE, en proportion de la taille du tableau A L'ECRAN. Figee a
    // 6 px de decalage et 18 px de diffusion, elle entourait un 30x20 d'un
    // halo gris aussi epais qu'une baguette, que Pablo a lu comme « une
    // sorte de cadre gris » sur les tableaux sans cadre (2026-07-31).
    // TRANCHE DE LA TOILE. Trois centimetres reels, uniquement quand aucune
    // moulure n'est choisie : une toile encadree n'a pas de tranche visible.
    // EPAISSEUR EN MILLIMETRES. Une toile sur chassis fait bien 3 cm, mais
    // les trois scenes sont photographiees DE FACE : de face, on ne voit
    // presque rien de la tranche, seulement l'arete. Poser 3 cm a plat
    // donnait une bande large qui se lisait comme une ombre (releve de
    // Pablo). Le reglage descend donc au millimetre.
    const epTrancheMm = Number(scene.dataset.trancheMm || 10);
    const tranchePx = cadreVisible ? 0 : (baseLargeur * (epTrancheMm / 10) * echelle) / 100;
    oeuvre.style.setProperty('--pn-tranche', `${Math.max(0, Math.round(tranchePx))}px`);
    oeuvre.style.setProperty('--pn-tranche-ombre',
      String(Number(scene.dataset.trancheOmbre || 16) / 100));
    oeuvre.style.setProperty('--pn-arete',
      String(Number(scene.dataset.arete || 12) / 100));
    oeuvre.style.setProperty('--pn-lumiere-oeuvre',
      String(Number(scene.dataset.lumiere || 5) / 100));

    const intensite = Number(scene.dataset.ombre || 18) / 100;
    const largeurPx = (baseLargeur * largeurCm * echelle) / 100;
    // OMBRE DIRECTIONNELLE, en deux couches. La lumiere vient de la gauche
    // sur les trois scenes : l'ombre tombe donc a droite et vers le bas. Une
    // couche serree fait le contact avec le mur, une couche large fait
    // l'ambiance. Une ombre unique et symetrique donnait un rectangle
    // flottant, ce que Pablo a lu comme un copier-coller.
    const dx = largeurPx * 0.012;
    const dy = largeurPx * 0.020;
    oeuvre.style.setProperty(
      '--pn-ombre-oeuvre',
      intensite > 0 && largeurPx
        ? `${dx.toFixed(1)}px ${dy.toFixed(1)}px ${(largeurPx * 0.020).toFixed(1)}px rgb(0 0 0 / ${(intensite * 0.9).toFixed(2)}), `
          + `${(dx * 2).toFixed(1)}px ${(dy * 2).toFixed(1)}px ${(largeurPx * 0.11).toFixed(1)}px rgb(0 0 0 / ${(intensite * 0.55).toFixed(2)})`
        : 'none'
    );
    oeuvre.hidden = false;

    // Temoin de calibrage : un carre de 100 cm au meme facteur.
    const temoin = scene.querySelector('[data-pn-echelle-temoin]');
    if (temoin) {
      temoin.style.width = `${100 * echelle}%`;
      temoin.style.height = `${100 * echelle}%`;
      temoin.style.left = `${centreH}%`;
      temoin.style.top = `${sol - hauteurCentre * echelle}%`;
    }

    const legende = scene.querySelector('[data-pn-echelle-legende]');
    // Le suffixe vient de la scene, et de la traduction : « sur un mur de
    // salon » etait fige ici, donc la vue rapprochee sur un meuble annoncait
    // elle aussi un mur de salon (releve de Pablo le 2026-08-01). Aucun
    // libelle francais en dur, c'est la regle du vault.
    if (legende) {
      const suffixe = scene.dataset.suffixe || '';
      legende.textContent = suffixe
        ? `${largeurCm} x ${hauteurCm} cm, ${suffixe}`
        : `${largeurCm} x ${hauteurCm} cm`;
    }

    const choisi = [...document.querySelectorAll('.pn-variantes__champ:checked')].map((c) => c.value);
    scene.querySelectorAll('[data-pn-calque]').forEach((el) => {
      el.hidden = !choisi.includes(el.dataset.pnCalque);
    });
  }

  // PIEGE CORRIGE le 2026-08-02, et il vidait les trois scenes de leur
  // contenu. Une image en `loading="lazy"` placee dans une vue masquee par
  // `hidden`, donc en `display: none`, n'a AUCUNE boite : l'observateur qui
  // declenche le chargement differe ne se declenche jamais. En devoilant la
  // vue, le navigateur ne rattrape pas systematiquement le chargement, et
  // Pablo voyait « du blanc » a la place de la piece et du tableau.
  // On repasse donc en chargement immediat les images de la vue qu'on
  // affiche, et seulement celles-la : le differe reste en place pour les
  // vues qu'on n'a pas ouvertes.
  function reveillerImages(vue) {
    if (!vue) return;
    vue.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      // On se contente de repasser en chargement immediat. La reaffectation
      // de `src` a ete essayee et ecartee : sur une image qui porte un
      // `srcset`, elle relance une selection de source et laissait l'image
      // en erreur, largeur naturelle nulle. Le changement d'attribut suffit
      // a declencher le chargement (verifie le 2026-08-02).
      img.loading = 'eager';
    });
  }

  // CALQUE SERVI A SA TAILLE REELLE.
  // `border-image` decoupe la source en neuf zones. Si la decoupe fait 128
  // pixels dans le fichier et que la moulure n'en occupe que 11 a l'ecran,
  // le navigateur comprime d'un facteur douze, et le raccord entre un coin
  // et un cote laisse une ligne claire. C'est la cause du lisere que trois
  // correctifs successifs n'avaient pas fait disparaitre : ils agissaient
  // sur la jointure avec l'oeuvre, alors que le defaut etait dans la
  // moulure elle-meme.
  // On demande donc la source a la taille exacte d'affichage, en pixels
  // REELS d'ecran, et on regle la decoupe pour qu'elle vaille l'epaisseur.
  // Rapport de reduction : un pour un.
  function calerSourceCalque(el, epaisseurPx) {
    const source = el.dataset.pnCalqueSource;
    if (!source || !epaisseurPx) return;
    const densite = Math.min(3, window.devicePixelRatio || 1);
    // `part` est la part de la source qu'occupe la moulure, en pourcentage
    // (25 % pour une decoupe de 128 sur 512).
    const part = Number(el.dataset.pnCalquePart || 25) / 100;
    const decoupe = Math.max(8, Math.round(epaisseurPx * densite));
    const largeur = Math.max(32, Math.round(decoupe / part));
    const separateur = source.includes('?') ? '&' : '?';
    // FOND DE MOULURE. La derniere rangee de pixels d'un `border-image`
    // reduit est lissee avec le vide qui la suit : elle devient a moitie
    // transparente, et ce qu'il y a derriere transparait sous forme d'une
    // ligne pale. C'est le dernier residu du lisere, celui que Pablo voit
    // encore a droite le 2026-08-02. Les quatre fichiers de moulure ont ete
    // mesures : leur partie opaque fait exactement le quart de l'image, la
    // decoupe est donc juste, le defaut vient du lissage, pas du reglage.
    // On pose la texture du cadre en fond de la boite : ce qui transparait
    // n'est plus la page ni le mur, mais la moulure elle-meme. La ligne
    // disparait sans qu'on ait a deviner une couleur.
    const boite = el.closest('[data-pn-zone]') || el.parentElement;
    if (boite) {
      boite.style.backgroundImage = `url(${source}${separateur}width=64)`;
      boite.style.backgroundSize = 'cover';
      boite.style.backgroundPosition = 'center';
    }
    if (el.dataset.pnCalqueLargeur === String(largeur)) return;
    el.dataset.pnCalqueLargeur = String(largeur);
    el.style.borderImageSource = `url(${source}${separateur}width=${largeur})`;
    el.style.borderImageSlice = String(decoupe);
  }

  // Sans finition encadree, aucun fond a poser : la toile nue se detache sur
  // le fond de page, et un fond de moulure y ferait une bordure fantome.
  function effacerFondCadre(boite) {
    if (!boite) return;
    boite.style.backgroundImage = '';
    boite.style.backgroundSize = '';
    boite.style.backgroundPosition = '';
  }

  function afficherMedia(id) {
    if (!id) return;
    document.querySelectorAll('[data-pn-media]').forEach((d) => {
      d.hidden = d.dataset.pnMedia !== String(id);
      if (!d.hidden) reveillerImages(d);
    });
    document.querySelectorAll('[data-pn-choisir-media]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.pnChoisirMedia === String(id)));
    });
  }

  function majSelection() {
    const choix = selectionCourante();
    const v = variantes.find((x) => x.options.every((o, i) => o === choix[i]));

    // Libelle de l'option a cote de son intitule.
    document.querySelectorAll('[data-pn-valeur-option]').forEach((el, i) => {
      if (choix[i]) el.textContent = choix[i];
    });

    if (!v) {
      bouton.disabled = true;
      bouton.textContent = libelleIndispo;
      return;
    }
    champId.value = v.id;
    zonePrix.textContent = formatPrix(v.prix);
    // On ne change PAS de vue quand l'acheteur en a choisi une. Sans cette
    // garde, selectionner un cadre ou une taille le renvoyait sur la
    // premiere image, alors qu'il regardait justement la seconde pour voir
    // le cadre. Releve deux fois par Pablo.
    if (!vueChoisieALaMain) afficherMedia(v.media);
    afficherCalque();
    placerAEchelle();

    // AUCUN libelle de pre-commande. PN compte 23 299 variantes qui le
    // declencheraient. On distingue seulement disponible ou non.
    bouton.disabled = !v.disponible;
    bouton.textContent = v.disponible ? libelleAchat : libelleIndispo;
  }

  // Choisir une finition de cadre AMENE sur la vue encadree. C'est la
  // demande de Pablo du 2026-08-01, et elle a une logique commerciale :
  // cliquer sur une pastille de cadre, c'est demander a voir ce cadre. Le
  // laisser sur la mise en situation obligeait a cliquer une seconde fois
  // sur la vignette pour constater son choix.
  // Seule la SECONDE image porte le calque, c'est donc elle qu'on amene.
  const vueEncadree = (() => {
    const zone = document.querySelector('[data-pn-zone]');
    const visuel = zone && zone.closest('[data-pn-media]');
    return visuel ? visuel.dataset.pnMedia : null;
  })();

  // On reconnait le selecteur de finition a sa PASTILLE, et non a la liste
  // des calques : « Oeuvre sur chassis » n'en a pas, et c'est pourtant une
  // finition comme les autres. La choisir doit aussi amener sur la vue de
  // l'oeuvre, cette fois sans moulure.
  function estUneFinition(champ) {
    const etiquette = champ.nextElementSibling;
    return !!etiquette && etiquette.classList.contains('pn-variantes__pastille');
  }

  /* ----- Ramener le tableau a l'ecran, telephone -------------------------
     En telephone la galerie est EMPILEE au-dessus des options : arrive aux
     pastilles, l'acheteur a le tableau entierement sorti par le haut. Il
     changeait donc de finition sans rien voir, et devait remonter a la main
     (releve de Luis le 2026-08-13 ; mesure sur 375 x 812, le bas de l'image
     est a -19 px quand les pastilles sont a l'ecran, donc zero pixel de
     tableau visible).

     LA CIBLE : le HAUT DU TABLEAU vient se caler juste sous l'en-tete
     collante. Le tableau est donc montre EN ENTIER, cadre compris, sur tous
     les telephones.

     Une premiere version calait le bas du bouton d'achat en bas d'ecran, ce
     qui gardait les pastilles a l'ecran et laissait voir 61 % du tableau sur
     un ecran de 812 px. Essayee par Luis le 2026-08-14 sur iPhone SE 2022,
     elle ne remontait pas assez : cet ecran ne fait que 667 px, et il n'en
     restait que 18 % de tableau. Arbitrage rendu le meme jour, on montre
     le tableau en entier.

     CE QUE CET ARBITRAGE COUTE, et il faut le savoir avant d'y toucher : les
     pastilles quittent l'ecran. Du haut du tableau au bas des pastilles il y
     a 811 px, quand un iPhone SE n'offre que 603 px sous l'en-tete. Les deux
     ne tiennent pas ensemble, c'est de la geometrie et non un reglage a
     affiner. Essayer une deuxieme finition demande donc de redescendre.
     Seule une galerie collante en telephone donnerait les deux, et c'est une
     refonte de la mise en page, pas un correctif.

     En bureau, rien : la colonne d'achat est collante et la galerie est a
     cote, donc toujours a l'ecran.
  ------------------------------------------------------------------------ */
  function ramenerLeTableau() {
    if (matchMedia('(min-width: 990px)').matches) return;
    const vue = [...document.querySelectorAll('[data-pn-media]')].find((d) => !d.hidden);
    if (!vue) return;

    // Ce qui est cache derriere l'en-tete collante ne compte pas comme vu.
    const hautCollant = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--pn-offset-collant')
    ) || 0;
    const b = vue.getBoundingClientRect();
    const vu = Math.max(0, Math.min(b.bottom, innerHeight) - Math.max(b.top, hautCollant));
    // Deja entierement a l'ecran : on ne bouge pas. Un defilement automatique
    // qui se declenche pour rien est plus penible que le defaut qu'il
    // corrige. Le seuil est haut, 90 %, parce que la cible est desormais de
    // tout montrer : a 60 % de tableau visible, il reste quelque chose a
    // gagner.
    if (!b.height || vu / b.height >= 0.9) return;

    const ecart = b.top - (hautCollant + 8);
    // On ne descend jamais, et on ne bouge pas pour trois fois rien.
    if (ecart > -24) return;

    scrollBy({
      top: ecart,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  document.querySelectorAll('.pn-variantes__champ')
    .forEach((c) => c.addEventListener('change', () => {
      majSelection();
      // ON NE BOUGE PAS SI L'ACHETEUR EST DEJA SUR UNE SCENE. Elle porte le
      // meme calque de cadre, donc c'est un poste de comparaison legitime :
      // le renvoyer sur l'oeuvre a plat a chaque pastille l'empechait
      // justement de comparer les finitions au mur (releve de Pablo le
      // 2026-08-01). Meme raisonnement pour la vue de detail.
      const vueActuelle = [...document.querySelectorAll('[data-pn-media]')].find((d) => !d.hidden);
      const surUneVueDediee = !!vueActuelle
        && (vueActuelle.hasAttribute('data-pn-scene') || vueActuelle.dataset.pnMedia === 'detail');
      if (vueEncadree && estUneFinition(c) && !surUneVueDediee) {
        afficherMedia(vueEncadree);
        // La vue est desormais tenue : sans ce marqueur, le prochain
        // changement de taille renverrait sur la mise en situation.
        vueChoisieALaMain = true;
        afficherCalque();
      }
      // En dernier, une fois la bonne vue posee : elle mesure ce qui est
      // affiche, pas ce qui l'etait avant.
      ramenerLeTableau();
    }));

  // Des que l'acheteur clique une vignette, on considere qu'il pilote la
  // galerie : le changement de variante ne la reprend plus.
  document.querySelectorAll('[data-pn-choisir-media]')
    .forEach((b) => b.addEventListener('click', () => {
      vueChoisieALaMain = true;
      afficherMedia(b.dataset.pnChoisirMedia);
      // L'epaisseur du cadre se MESURE sur la zone de l'oeuvre. Tant que
      // cette vue est masquee, elle est en `display: none` et toute mesure y
      // vaut zero : choisir un cadre en regardant la premiere image ne
      // posait donc rien, et la moulure apparaissait a une epaisseur
      // quelconque au moment de basculer. On recalcule a l'affichage.
      afficherCalque();
    }));

  majSelection();
  afficherCalque();
  placerAEchelle();

  // Deux recalculs de rattrapage. Les deux mecaniques qui MESURENT la page,
  // l'epaisseur du cadre et l'ombre portee de la scene, donnent des valeurs
  // fausses tant que la grille de la fiche n'est pas posee : au premier
  // passage, la galerie ne fait pas encore sa largeur definitive. Une fois
  // la mise en page faite, puis a chaque changement de largeur de fenetre,
  // on repasse dessus.
  requestAnimationFrame(() => { afficherCalque(); placerAEchelle(); });
  addEventListener('load', () => { afficherCalque(); placerAEchelle(); }, { once: true });
  let attente;
  addEventListener('resize', () => {
    clearTimeout(attente);
    attente = setTimeout(() => { afficherCalque(); placerAEchelle(); }, 150);
  }, { passive: true });
}


/* ==========================================================================
   Produits complementaires.
   Shopify ne peut pas calculer ses recommandations pendant le rendu de la
   page : il faut les demander apres coup. On ne le fait qu'a l'approche de
   la section, pour ne rien couter tant que le visiteur n'y arrive pas.
   Si la requete echoue, la collection de repli rendue cote serveur reste
   affichee : la section ne se vide jamais.
   ========================================================================== */
const zoneReco = document.querySelector('[data-pn-recommandes]');
if (zoneReco && 'IntersectionObserver' in window) {
  const observateur = new IntersectionObserver((entrees) => {
    if (!entrees.some((e) => e.isIntersecting)) return;
    observateur.disconnect();
    fetch(zoneReco.dataset.url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        const recu = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-pn-recommandes]');
        const grille = recu && recu.querySelector('.pn-grille');
        if (grille) zoneReco.querySelector('.pn-grille')?.replaceWith(grille);
      })
      .catch(() => { /* le repli serveur reste en place */ });
  }, { rootMargin: '600px' });
  observateur.observe(zoneReco);
}


/* ==========================================================================
   Barre d'achat collante, mobile.

   Elle n'apparait QUE lorsque le bouton principal est sorti de l'ecran :
   affichee en permanence, elle ferait doublon et mangerait de la hauteur.

   Calcul au defilement plutot qu'IntersectionObserver. Deux raisons : la
   position exacte du bouton est de toute facon lue pour decider, et le
   calcul est verifiable en recette, alors que l'observateur ne se declenche
   pas dans le navigateur de test. Le rappel est cale sur le rafraichissement
   de l'ecran, donc il ne coute rien.
   ========================================================================== */
/* Composant autonome plutot que du code au fil du module.

   Raison, constatee le 2026-07-30 : le meme fichier fonctionnait quand on
   l'importait a la main mais pas au chargement naturel de la page, le bloc
   de fin n'ayant visiblement pas le meme sort que le debut du module selon
   le moment ou Shopify sert l'asset. Un element personnalise ne depend
   d'aucun ordre : le navigateur appelle `connectedCallback` des que la
   definition existe, que l'element ait ete analyse avant ou apres. */
class PnAchatCollant extends HTMLElement {
  connectedCallback() {
    this.bouton = document.querySelector('[data-pn-ajouter]');
    if (!this.bouton) return;

    this.enAttente = false;
    this.planifier = () => {
      if (this.enAttente) return;
      this.enAttente = true;
      requestAnimationFrame(() => this.evaluer());
    };
    addEventListener('scroll', this.planifier, { passive: true });
    addEventListener('resize', this.planifier, { passive: true });
    this.evaluer();

    // Le bouton de la barre delegue au vrai bouton : une seule mecanique
    // d'ajout, donc un seul endroit ou se tromper.
    this.querySelector('[data-pn-achat-collant-bouton]')
      ?.addEventListener('click', () => this.bouton.click());
  }

  disconnectedCallback() {
    removeEventListener('scroll', this.planifier);
    removeEventListener('resize', this.planifier);
  }

  evaluer() {
    this.enAttente = false;
    const b = this.bouton.getBoundingClientRect();
    // La barre s'efface tant que le bouton principal est a l'ecran, et
    // reparait des qu'il en sort. Visible par defaut dans le balisage : si
    // le script ne tourne pas, il reste une barre d'achat utile.
    this.hidden = b.bottom > 80 && b.top < window.innerHeight;
  }
}

if (!customElements.get('pn-achat-collant')) {
  customElements.define('pn-achat-collant', PnAchatCollant);
}
